<template>
  <div id="login">
    <div class="container">
      <img :src="logoSrc" alt="User Image" class="logo-image" style="width: 50%; height: auto;" />
      <h1 class="title">{{ $t('UTBMP') }}</h1>

      <div class="input-group">
        <label for="username" class="label">{{ $t('username') }}:</label>
        <input
          type="text"
          id="username"
          name="username"
          placeholder="Username"
          v-model="input.username"
          class="input"
        />
      </div>
      <div class="input-group">
        <label for="password" class="label">{{ $t('password') }}:</label>
        <input
          type="password"
          id="password"
          name="password"
          placeholder="Password"
          v-model="input.password"
          class="input"
        />
      </div>

      <button type="button" @click="login">{{ $t('login') }}</button>
    </div>
  </div>
</template>
<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import { useI18n } from 'vue-i18n';
import { inject } from 'vue';
import Cookies from 'js-cookie';
import logoIcon from '@/assets/logo.png';

export default {
  name: 'LoginView',
  data() {
    return {
      input: {
        username: '',
        password: '',
      },
      logoSrc: logoIcon,
    };
  },
  setup() {
    const apiBaseUrl = inject('apiBaseUrl');
    const { t } = useI18n();
    return {
      apiBaseUrl,
      t,
    };
  },
  methods: {
    login() {
      if (this.input.username !== '' && this.input.password !== '') {
        const data = JSON.stringify({
          str: this.input.username,
          str2: this.input.password,
        });
        axios.post(`${this.apiBaseUrl}/login`, data).then((response) => {
          console.log(response);
          if (response.data.success) {
            if (response.data.result.freeze === 1) {
              Swal.fire({
                position: 'center',
                icon: 'warning',
                title: this.t('accountFrozen'),
                showConfirmButton: false,
                timer: 1800,
              });
              return;
            }
            Cookies.set('jwt', response.data.message, { expires: 2 });
            localStorage.setItem('user', JSON.stringify(response.data.result));
            this.$router.push('/');
          } else {
            Swal.fire({
              position: 'center',
              icon: 'error',
              title: '登入失敗，請檢查帳號密碼是否正確。',
              showConfirmButton: false,
              timer: 1800,
            });
          }
        });
      } else {
        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'A username and password must be present',
          showConfirmButton: false,
          timer: 1800,
        });
      }
    },
  },
};
</script>
<style>
#login {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

#login .container {
  width: 500px;
  border: 1px solid #ccc;
  padding: 20px;
  padding-top: 0px;
  border-radius: 8px;
  text-align: center;
  background: white;
}

#login .container img {
  width: 500px;
}

#login .title {
  margin-bottom: 20px;
}

#login .input-group {
  display: flex;
  align-items: center;
  margin-top: 20px;
}

#login .label {
  flex: 1;
  text-align: left;
  margin-right: 10px;
  font-size: 24px;
}

#login .input {
  flex: 1;
  outline-style: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  padding: 10px;
  font-size: 24px;
}

#login button {
  background-color: #4285f4;
  color: white;
  width: 100%;
  height: 45px;
  border: 0;
  font-size: 16px;
  border-radius: 5px;
  margin-top: 20px;
}

#login button:hover {
  background-color: #1b458a;
}
</style>
